import CheckOutContainer from "modules/CartCheckOut/containers/CheckOutContainer";

type Props = {}

const CheckOut = (props: Props) => {
    return (
        <CheckOutContainer
        />
    )
}

export default CheckOut;